// This file is auto-generated using the 'icon-generator' package.
// Any changes made to this file manually will be lost the next time the
// file is generated

import * as React from "react";
import { MappedProps, PassedProps, useMappedProps } from "./useMappedProps";

const Icon: React.ComponentType<
  Omit<React.SVGProps<SVGSVGElement>, keyof MappedProps> & PassedProps
> = (passedProps) => {
  const props = useMappedProps(passedProps);
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        d="M2.583.037A2.267 2.267 0 0 0 .901 1.44C.746 1.848.758 1.43.749 6.6c-.008 4.887-.004 5.121.094 5.687.33 1.908 1.531 3.926 3.71 6.23 1.544 1.633 3.81 3.515 5.92 4.914.713.474.927.552 1.515.554.62.002.815-.072 1.656-.635 2.454-1.642 4.871-3.726 6.53-5.629 1.702-1.951 2.694-3.758 2.983-5.434.098-.566.102-.8.094-5.687-.008-4.378-.011-4.702-.05-4.848-.16-.591-.472-1.045-.941-1.368a2.871 2.871 0 0 0-.696-.318l-.192-.054L12.06.008C4.265.005 2.721.01 2.583.038m.17 1.509a.769.769 0 0 0-.452.448c-.043.113-.045.298-.045 4.817 0 3.97.005 4.74.035 4.962.062.465.149.81.33 1.306.131.36.578 1.246.837 1.657 1.236 1.967 3.425 4.178 6.214 6.278.917.69 1.914 1.376 2.093 1.439a.856.856 0 0 0 .47 0c.169-.06 1.057-.667 1.949-1.332 2.187-1.63 4.079-3.397 5.388-5.03 1.092-1.362 1.823-2.735 2.065-3.88.108-.512.107-.438.107-5.4 0-4.646 0-4.7-.048-4.827a.87.87 0 0 0-.364-.406l-.104-.055-9.192-.005c-7.695-.004-9.207 0-9.283.028m15.76 2.398a.767.767 0 0 0-.304.194c-.023.027-1.824 2.303-4.002 5.057-2.242 2.837-3.981 5.016-4.01 5.025a.413.413 0 0 1-.256-.01c-.078-.042-.144-.132-1.407-1.93-.657-.933-1.228-1.731-1.27-1.773a.764.764 0 0 0-.837-.133.755.755 0 0 0-.379.934c.054.141 2.48 3.606 2.692 3.845.674.757 1.87.792 2.594.074.182-.18 8.029-10.126 8.098-10.264.075-.15.084-.38.02-.57a.856.856 0 0 0-.372-.411.943.943 0 0 0-.568-.038"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
};

const GuardCheckIcon = Icon;
export default GuardCheckIcon;
